import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetStudentMemos, IStudentMemoReq } from '../models/studentsMemos.model';

const uri = '/mgmt/students/memos';

export const getStudentMemos = (campusCode: string, studentCode: string): AxiosPromise<IGetStudentMemos> => {
  return axios.get(`${uri}/${campusCode}/${studentCode}`);
}

export const createStudentMemo = (studentCode: string, data: IStudentMemoReq): AxiosPromise => {
  return axios.post(`${uri}/${studentCode}`, data);
};

export const updateStudentMemo = (studentCode: string, data: IStudentMemoReq): AxiosPromise => {
  return axios.put(`${uri}/${studentCode}/update`, data);
};

export const deleteStudentMemo = (memoCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${memoCode}`);
};
